/**
 * patrol-obedience-edit.js
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { shouldRenderMobileLayout } from 'utils/app-context';
import { EditorIconSection } from 'components/icon-section/icon-section';
import HelpTextItem from 'components/menu-drawer/help-text-item';
import HiddenInput from 'components/form-inputs/hidden-input';
import CheckboxList from 'components/form-inputs/checkbox-list';
import { PatrolTypeTitle } from '../../training-utils';


export default function PatrolObedienceEdit(props) {
  const {
    patrolRecord,
    patrolIndex,
    patrolTypes,
    drawerState,
    translation,
    options,
    formPrefix = '',
  } = props;
  const formNameBase = `${formPrefix}patrol.patrolTypes[${patrolIndex}].obedience`;
  const typeRecord = patrolRecord?.obedience;
  const { t } = useTranslation(translation);


  return (
    <>
      <EditorIconSection
        iconName='patrol-obedience'
        iconMarginTop={0}
        helpProps={{
          translation,
          section: 'obedience',
          suffix: patrolTypes.length > 1 ? ` (Scenario)` : '',
        }}
      >
        {!shouldRenderMobileLayout() &&
        <PatrolTypeTitle 
          patrolType={patrolRecord.type} 
          patrolTypes={patrolTypes} 
          step={patrolRecord.order}
        />}


        {/* id */}
        <HiddenInput 
          name={`${formNameBase}.id`}
          defaultValue={typeRecord?.id || ''}
        />


        {/* obedience types */}
        <HelpTextItem
          sidebarText={drawerState.sidebarText}
          title={t('obedience.types.helpTitle')}
          text={t('obedience.types.helpInfo')}
          style={{ marginTop: 4 }}
        >
          {focusHandlers =>
            <CheckboxList
              name={`${formNameBase}.types`}
              label={t('obedience.types.label')}
              options={options.obedienceTypes}
              focusHandlers={focusHandlers}
              defaultValue={typeRecord?.types}
              customOther
              rules={{
                validate: val => (val && val.length > 0) || t('obedience.types.errMsgEmpty')
              }}
            />}
        </HelpTextItem>
      </EditorIconSection>
    </>
  );
}